import { useDelayedState } from "./useDelayedState";
/**
 * A hook for handling hover delays.
 *
 * @example
 *
 * ```js
 * const { bindHoveringTooltip, shouldMountTooltip } = useHover(isShowing);
 *
 * return (
 *   <div {...bindHoveringTooltip} style={{ opacity: shouldMountTooltip ? 1 : 0 }}>
 *     Lame-o example popover
 *   </div>
 * )
 * ```
 */

export function useHover(isShowing) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$delayIn = _ref.delayIn,
      delayIn = _ref$delayIn === void 0 ? 0 : _ref$delayIn,
      _ref$enableDelay = _ref.enableDelay,
      enableDelay = _ref$enableDelay === void 0 ? true : _ref$enableDelay;

  var delayedVisibility = useDelayedState(isShowing, {
    delay: isShowing ? delayIn : 0,
    initialState: isShowing,
    enabled: enableDelay
  });
  return {
    shouldMountTooltip: delayedVisibility
  };
}